export default __webpack_public_path__ + "static/media/dan.ef77f827.png";